import $ from 'jquery';
import 'tinymce';
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/themes/silver/theme';
import 'tinymce/icons/default/icons';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';

const TINY_MCE_IMAGES_ENDPOINT = "/admin/tiny_mce_images";

function error(msg) {
  tinymce.activeEditor.windowManager.alert(msg);
}

function show_spinner(spin) { tinymce.activeEditor.setProgressState(spin); }

function upload_file(file, url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('X-CSRF-Token', $("meta[name='csrf-token']").attr('content'))
  xhr.onload = function () { callback(xhr); };
  const data = new FormData();
  data.append('file', file, file.name);
  xhr.send(data);
}

function upload_image(image_file, success, failure) {
  if (!image_file.type.match('image.*')) {
    return failure('Opgegeven upload is geen afbeelding.');
  }

  show_spinner(true);
  upload_file(image_file, TINY_MCE_IMAGES_ENDPOINT, (res) => {
    show_spinner(false);
    if (res.status == 200) {
      success(JSON.parse(res.response).location, { alt: image_file.name });
    } else {
      failure('Deze afbeelding kon niet geupload worden');
    }
  });
}

function images_upload_handler(blobInfo, success, failure) {
  upload_image(blobInfo.blob(), success, failure);
}

// Config
// ======
const default_config = {
  selector: 'textarea.tinymce',
  menubar: false,
  skin: false,
  content_css: false,
  toolbar: 'undo redo | styleselect | alignleft aligncenter alignright alignjustify | bold italic underline | bullist numlist | link unlink | paste pastetext | code removeformat',
  theme_advanced_toolbar_location: 'top',
  theme_advanced_buttons1: 'bold,italic,underline,formatselect,|,charmap,cut,copy,paste,pastetext,pasteword,|,bullist,numlist,|,undo,redo,|,link,unlink,image,code',
  theme_advanced_buttons2: '',
  theme_advanced_buttons3: '',
  plugins: 'code paste link image',
  paste_use_dialog: false,
  paste_auto_cleanup_on_paste: true,
  paste_strip_class_attributes: 'all',
  paste_remove_spans: true,
  paste_remove_styles: true,
  theme_advanced_styles: 'external=external'
};

const image_uploads_config = $.extend({}, default_config, {
  selector: 'textarea.tinymce--with_image_uploads',
  automatic_uploads: true,
  toolbar: 'undo redo | styleselect | alignleft aligncenter alignright alignjustify | bold italic underline | bullist numlist | link unlink | paste pastetext | image code',
  paste_data_images: true,
  images_upload_url: TINY_MCE_IMAGES_ENDPOINT,
  file_picker_types: 'image',
  images_upload_handler
});

document.addEventListener('DOMContentLoaded', () => {
  tinymce.init(default_config);
  tinymce.init(image_uploads_config);
});
